import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherScheduleException/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherScheduleException/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherScheduleException/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherScheduleException/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      url: 's7x_TeacherScheduleException/Delete',
      data,
    });
  },
};
